export default {
  unitLabel: {
    carbonNitrogen: 'Węgiel / Azot',
    thickness: 'Grubość',
  },
};
